// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Settings: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 57.1"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M28 12.8c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3zm0-7.9c-1.5 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.1-2.6-2.6-2.6zm21.1 50c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3zm0-7.9c-1.5 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6zM6.9 41.7c-2.9 0-5.3-2.4-5.3-5.3s2.4-5.3 5.3-5.3 5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3zm0-7.9c-1.5 0-2.6 1.2-2.6 2.6S5.5 39 6.9 39s2.6-1.2 2.6-2.6-1.1-2.6-2.6-2.6zm0-6.6c-.7 0-1.3-.6-1.3-1.3V2.2c0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3v23.7c.1.7-.5 1.3-1.3 1.3zm0 29c-.7 0-1.3-.6-1.3-1.3V47c0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3v7.9c.1.7-.5 1.3-1.3 1.3zm21.1 0c-.7 0-1.3-.6-1.3-1.3V18c0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3v36.8c0 .8-.6 1.4-1.3 1.4zm21.1-15.8c-.7 0-1.3-.6-1.3-1.3V2.2c0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3V39c0 .8-.6 1.4-1.3 1.4z"/></svg>;
};

export default React.memo(Settings);
